angular.module 'zc.users'

.controller 'ResetUserPasswordCtrl', ($scope, $state, $translate, $stateParams, Page, Devise, Project) ->
  $translate('users.controllers.password.resetPassword').then (translation) ->
    Page.setTitle translation

  Page.setBodyClass 'account-bg'
  $scope.submit = (user) ->
    # TODO: After moving everything to webpack, we can get rid of this rails generated way
    reset_password_token = $('meta[name="reset_password_token"]').attr('content')

    if reset_password_token
      Devise.resetPassword(reset_password_token, user.password, user.password_confirmation)
      .then (res) ->
        $state.go 'admin.home'
    else
      # The "webpack" way is to use stateparams
      Devise.resetPassword($stateParams.reset_password_token, user.password, user.password_confirmation)
      .then (res) ->
        Devise.signIn(res.email, user.password, true)
      .then () ->
        $state.go 'admin.home'



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/users/controllers/password/reset_password_controller.js.coffee